import styles from './FooterConnect.module.css';

const socialLinks = [
  { name: 'Instagram', href: 'https://www.instagram.com/samanthashenolguin' },
  { name: 'Facebook', href: 'https://www.facebook.com/samanthashenogluin ' },
  { name: 'YouTube', href: 'https://www.youtube.com/@samanthashenolguin' },
  { name: 'TikTok', href: 'https://www.tiktok.com/@samanthashenolguin' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/in/samanthashenolguin/'},
  { name: 'Amazon Author Page', href: 'https://www.amazon.com/author/samanthashen' },
];

const FooterConnect = () => {
  return (
    <div className={styles.connectSection}>
      <h3 className={styles.title}>connect.</h3>
        <div className={styles.column}>
          {socialLinks.map((link) => (
            <a key={link.name} href={link.href} target="_blank" rel="noreferrer" className={styles.link}>
              {link.name}
            </a>
          ))}
        </div>
      </div>
  );
};

export default FooterConnect;